import { useState } from "react";
import { StyledButton } from "../../components/styled/styled-components";

interface IUploadButtonProps {
  onUploadFileSubmit: (csvFileArray: string[][]) => void;
  isLoading: boolean;
}

const UploadButton = ({ onUploadFileSubmit, isLoading }: IUploadButtonProps) => {
  const [csvFileArray, setCsvFileArray] = useState<string[][]>([]);

  const isValidLine = (line: string[]) => {
    const containsOnlyNumbers = (str: string) => /^\d+$/.test(str);
    if (line.length < 2) return false;
    if (line[0] === "" || !containsOnlyNumbers(line[0])) return false;
    if (line[1] === "" || !containsOnlyNumbers(line[1])) return false;
    return true;
  };

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event) return;

    const uploadedCSV =
      event.target.files && event.target.files.length > 0 && event.target.files[0];
    if (uploadedCSV) {
      return new Promise((resolve, reject) => {
        const csv = uploadedCSV;
        const reader = new FileReader();

        reader.onload = (evt) => {
          const result = evt && evt.target && evt.target.result;
          if (typeof result === "string") {
            const lines = result.split("\n");
            lines.shift(); // Remove the header row
            const linesFormatted = lines.map((line) => line.split(","));
            const linesValid = linesFormatted.filter(isValidLine);
            resolve(setCsvFileArray([...linesValid]));
          }
        };

        reader.onerror = (e) => {
          reject(e);
        };

        reader.readAsText(csv);
      });
    }
  };

  return (
    <div className="util">
      <div className="inputs">
        <input type="file" id="file-upload" accept=".csv" onChange={handleFileUpload} />
        {csvFileArray.length > 0 && <p>{csvFileArray.length} items found.</p>}
      </div>

      <StyledButton
        onClick={() => onUploadFileSubmit(csvFileArray)}
        disabled={isLoading || csvFileArray.length === 0}
      >
        {isLoading ? "Importing..." : "Import"}
      </StyledButton>
    </div>
  );
};

export default UploadButton;
